<!-- Page Header Start -->
<app-pageheader [pageOptions]="pageOptions"></app-pageheader>
<!-- Page Header End -->

<!-- Page content Start -->
<div class="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <!-- Small Primary Start -->
  <div id="SMALL_PRIM_SECTION">
    <h1 class="mb-4">{{ "small_primary" | translate }}</h1>
    <app-articles-view
      [articles]="smallPrimArticlesArray"
      [itemsPerPage]="smallPrimLimit"
      [totalcount]="smallPrimTotalcount"
      [articleSection]="'SMALL_PRIM_SECTION'"
      (onPaginateEvent)="onSmallPrimPaginateEvent($event)"
    ></app-articles-view>
  </div>
  <!-- Big Primary End -->
  <br /><br /><br />
  <div id="BIG_PRIM_SECTION">
    <h1 class="mb-4">{{ "big_primary" | translate }}</h1>
    <app-articles-view
      [articles]="bigPrimArticlesArray"
      [itemsPerPage]="bigPrimLimit"
      [totalcount]="bigPrimTotalcount"
      [articleSection]="'BIG_PRIM_SECTION'"
      (onPaginateEvent)="onBigPrimPaginateEvent($event)"
    ></app-articles-view>
  </div>
  <!-- Big Primary End -->
</div>
<!-- Page content End-->
